module.exports = __webpack_public_path__ + "img/logo.5167a8aa.png";